"use client";

import { BookOpen, Lightbulb, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  icon: Lightbulb,
  title: "Product Development Consulting",
  description: "Guiding early-stage exploration, development, testing, and scale-up.",
  link: "/ProductDevelopmentConsultingPage"
}, {
  id: 2,
  icon: BookOpen,
  title: "White-Label Product Support",
  description: "Turnkey, brand-ready product development and private-label customization.",
  link: "/PrivateLabelProductSupportPage"
}, {
  id: 3,
  icon: Shield,
  title: "IP / M&A Services",
  description: "Rigorous technical evaluation to support intellectual property, diligence, and engineering decisions.",
  link: "/DueDiligenceSupportPage"
}];
export default function OurServiceOfferings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative bg-dark-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <h2 className={`font-sans text-3xl md:text-5xl font-semibold text-white text-center mb-12 md:mb-16 tracking-wide leading-tight transition-all duration-[var(--duration-medium)] ${isVisible ? "animate-fade-in-up" : "opacity-0 translate-y-4"}`}>
          Explore our three core service areas
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`bg-background border border-border shadow-soft transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`}>
                <CardHeader>
                  <div className="mb-4">
                    <Icon className="size-10 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter>
                  <Link to={service.link}>
                    <Button variant="outline" className="group relative overflow-hidden hover:scale-[1.02] active:scale-100 transition-transform duration-[120ms] ease-[cubic-bezier(0.4,0,0.2,1)]">
                      <span className="relative z-10">Learn More</span>
                      <span className="absolute inset-0 bg-primary/5 scale-0 group-active:scale-100 transition-transform duration-300 rounded-md" />
                    </Button>
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}